import ReferralContainer from '../../../containers/ReferralContainer'

const Referrals = () => {
  return <ReferralContainer />
}

export default Referrals
